import space2CheckReportService from '../../api/spaceoccupancydashboard'
import { DASHBOARD_OCCUPANCY } from '../types'
import errorhandler from '@/utils/errorhandler.js'
import filedownloader from '@/utils/filedownloader.js'

export default {
  namespaced: true,
  state: {
    isDownloadingFile: false,
  },
  mutations: {
    [DASHBOARD_OCCUPANCY.SET_IS_DOWNLOADING_FILE](state, value) {
      state.isDownloadingFile = value
    }
  },
  actions: {
    async getSpaceOccupancyTreeView(_, payload) {
      try {
        const response = await space2CheckReportService.getSpaceOccupancyTreeView(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getGeneralOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getGeneralOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getBusiestDateOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getBusiestDateOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getBusiestTimeOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getBusiestTimeOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getWastageOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getWastageOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getPositionsOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getPositionsOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getRoomsRankingOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getRoomsRankingOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getRoomsPositionsOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getRoomsPositionsOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getRoomsWastageOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getRoomsWastageOccupancy(payload)
          return response.data
        } catch (error) {
          errorhandler.handleError(error)
      }
    },
    async downloadSpaceOccupancyReportFile({ dispatch }, payload) {
      await filedownloader.downloadFile(
        space2CheckReportService.getSpaceOccupancyReportFile.bind(space2CheckReportService),
        'occupancy_report.xlsx',
        payload,
        dispatch
      )
    },
    setIsDownloadingFile({ commit }, value) {
      commit(DASHBOARD_OCCUPANCY.SET_IS_DOWNLOADING_FILE, value)
    },
    async getGeneralRoomOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getGeneralRoomOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getBusiestDateRoomOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getBusiestDateRoomOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getBusiestTimeRoomOccupancy(_, payload) {
      try {
        const response = await space2CheckReportService.getBusiestTimeRoomOccupancy(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getRoomsOccupancyPerDay(_, payload) {
      try {
        const response = await space2CheckReportService.getRoomsOccupancyPerDay(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    },
    async getRoomsOccupancyPerHour(_, payload) {
      try {
        const response = await space2CheckReportService.getRoomsOccupancyPerHour(payload)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      }
    }
  }
}
